var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonAlone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10C9.125 10 7.94792 9.51042 6.96875 8.53125C5.98958 7.55208 5.5 6.375 5.5 5C5.5 3.625 5.98958 2.44792 6.96875 1.46875C7.94792 0.489583 9.125 0 10.5 0C11.875 0 13.0521 0.489583 14.0312 1.46875C15.0104 2.44792 15.5 3.625 15.5 5C15.5 6.375 15.0104 7.55208 14.0312 8.53125C13.0521 9.51042 11.875 10 10.5 10ZM0.5 20V16.5C0.5 15.7917 0.682292 15.1406 1.04688 14.5469C1.41146 13.9531 1.89583 13.5 2.5 13.1875C3.79167 12.5417 5.10417 12.0573 6.4375 11.7344C7.77083 11.4115 9.125 11.25 10.5 11.25C11.875 11.25 13.2292 11.4115 14.5625 11.7344C15.8958 12.0573 17.2083 12.5417 18.5 13.1875C19.1042 13.5 19.5885 13.9531 19.9531 14.5469C20.3177 15.1406 20.5 15.7917 20.5 16.5V20H0.5ZM3 17.5H18V16.5C18 16.2708 17.9427 16.0625 17.8281 15.875C17.7135 15.6875 17.5625 15.5417 17.375 15.4375C16.25 14.875 15.1146 14.4531 13.9688 14.1719C12.8229 13.8906 11.6667 13.75 10.5 13.75C9.33333 13.75 8.17708 13.8906 7.03125 14.1719C5.88542 14.4531 4.75 14.875 3.625 15.4375C3.4375 15.5417 3.28646 15.6875 3.17188 15.875C3.05729 16.0625 3 16.2708 3 16.5V17.5ZM10.5 7.5C11.1875 7.5 11.776 7.25521 12.2656 6.76562C12.7552 6.27604 13 5.6875 13 5C13 4.3125 12.7552 3.72396 12.2656 3.23438C11.776 2.74479 11.1875 2.5 10.5 2.5C9.8125 2.5 9.22396 2.74479 8.73438 3.23438C8.24479 3.72396 8 4.3125 8 5C8 5.6875 8.24479 6.27604 8.73438 6.76562C9.22396 7.25521 9.8125 7.5 10.5 7.5Z",
    fill: "url(#paint0_linear_331_6660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_331_6660",
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAlone);
export default __webpack_public_path__ + "static/media/person_alone.5802da65d21d97b09c11765761af84ad.svg";
export { ForwardRef as ReactComponent };